import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import Link from '@material-ui/core/Link'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import DeleteIcon from '@material-ui/icons/Delete'
import Box from '@material-ui/core/Box'
import ViewAllDialog from '../ViewAllDialog'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../messages'
import DeleteDialog from './DeleteDialog'
import { configContext } from '../../utils/StandardReducer'
import ErrorIcon from '@material-ui/icons/Error'
import { TubeProduct, TubeProperties, Modification } from '../../utils/enum'
import { TableContainer } from '@material-ui/core'
import { isIEBrowser } from '../../utils/util'
import { ConfiguratorValues } from '../../utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  listContainer: {
    margin: theme.spacing(4, 0),
  },
  view: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  viewAll: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 1, 0, 0),
    justifyContent: 'flex-end',
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
    '& span': {
      width: '50%',
    },
    fontWeight: theme.typography.fontWeightMedium,
  },
  viewAllScroll: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    padding: theme.spacing(0, 0, 0, 2),
    justifyContent: 'flex-end',
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
    fontWeight: theme.typography.fontWeightMedium,
  },
  buttonTextIe: {
    padding: theme.spacing(0, 3.5, 0, 0),
  },
  viewAllScrollIE: {
    padding: theme.spacing(0, 2.5, 0, 0),
  },
  labelRoot: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey[500],
    wordBreak: 'break-all',
    fontWeight: theme.typography.fontWeightMedium,
  },
  button: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.dark,
    },
  },
  delete: {
    padding: theme.spacing(0),
    float: 'right',
  },
  divider: {
    margin: theme.spacing(1),
  },
  active: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    fontWeight: theme.typography.fontWeightMedium,
    '& $activeLabel': {
      color: theme.palette.primary.main,
    },
    wordBreak: 'break-all',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: theme.typography.fontWeightRegular,
  },
  listIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  errorIcon: {
    fontSize: theme.typography.pxToRem(18),
    verticalAlign: 'top',
    color: theme.palette.rich.red,
  },
  activeLabel: {},
  tableContainer: {
    maxHeight: 216,
  },
  deleteIcon: {
    fontSize: theme.typography.pxToRem(22),
    color: theme.palette.grey[400],
  },
}))
export interface OligoItem {
  label: string
  sequence: string
  bases: number
  scale: string
  id: number
  purification: string
  activeLink?: boolean
}

export interface ProductProps {
  addItemsFromSideNav?:
    | React.Dispatch<React.SetStateAction<any>>
    | null
    | boolean
  setActive: React.Dispatch<React.SetStateAction<any>>
  productType: string
}

const ProductsSummary: React.FC<ProductProps> = (props) => {
  const classes = useStyles()

  const { productType, setActive } = props
  const [dialogOpen, setDialogOpen] = useState(false)
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [delItem, setDelItem] = useState()
  const intl = useIntl()
  const isIE = isIEBrowser()
  const maxItems =
    productType === TubeProduct.iscaledna
      ? TubeProperties.MaximumOligosAllowedIscaledna
      : TubeProperties.MaximumOligosAllowed
  const { state, dispatch } = React.useContext(configContext)
  const {
    sessionData,
    isValidTotalValidation,
    OligoIndex,
    countryCode,
    totalValidationJSON,
    errorResponseJson,
    errorIcon,
    isTubePageLoad,
    currentOligoIndex,
    isRequiredFieldError,
  } = state
  const [scrollBar, setScrollBar] = useState(false)
  const delType = 'Selected'

  const header = () => {
    return (
      <span className={classes.heading}>
        <FormattedMessage
          {...messages[`CONF_MY_OLIGOS_SIDE_BAR_${productType}`]}
        />
      </span>
    )
  }

  const setInitialState = () => {
    if (sessionData.length !== 0 && sessionData[0].applyToAll) {
      return {
        additionalCarrierProtein: sessionData[0].additionalCarrierProtein,
        additionalComments: '',
        additionalServices: sessionData[0].additionalServices,
        amount: sessionData[0].amount,
        applyToAll: false,
        autoValidation: '',
        baseCount: 0,
        carrierProtein: '',
        cartId: '',
        comments: '',
        concentration: sessionData[0].concentration,
        conjugation: sessionData[0].conjugation,
        conjugationAmount: sessionData[0].conjugationAmount,
        conjugationChemistry: sessionData[0].conjugationChemistry,
        countryCode: countryCode,
        crossContamination: '',
        crRnaType: '',
        cterminalMod: '',
        currencySymbol: '',
        customPeptideType: '',
        epsilon: 0,
        fiveMod: '',
        fiveModCategory: '',
        flag: sessionData[0].flag,
        format: sessionData[0].format,
        fullSOligoBackbone: false,
        gcContent: '',
        id: (state.oligoCount + 1).toString(),
        internalModCategory: '',
        isLabelledAminoAcid: true,
        isoCode: false,
        isOverridden: false,
        itemId: '',
        listError: [
          {
            key: '',
            value: '',
          },
        ],
        material: '',
        meltingTemparature: '',
        minimumYield: '',
        molecularWeight: '',
        name: '',
        nterminalMod: '',
        oligoId: state.oligoCount + 1,
        orderItemId: '',
        otherValue: sessionData[0].otherValue,
        packageType: '',
        plateType: '',
        price: '',
        primerDimer: '',
        productType: productType,
        purification: sessionData[0].purification,
        purityLevel: sessionData[0].purityLevel,
        quantitation: '',
        scale: sessionData[0].scale,
        secondaryStructure: '',
        sequence: '',
        sequenceLocation: '',
        threeMod: '',
        threeModCategory: '',
        tubes: sessionData[0].tubes,
      }
    }
    return {
      additionalCarrierProtein: 'None',
      additionalComments: '',
      additionalServices: [],
      amount: '',
      applyToAll: false,
      autoValidation: '',
      baseCount: 0,
      carrierProtein: '',
      cartId: '',
      comments: '',
      concentration: '',
      conjugation: 'None',
      conjugationAmount: '',
      conjugationChemistry: '',
      countryCode: countryCode,
      crossContamination: '',
      crRnaType: '',
      cterminalMod: '',
      currencySymbol: '',
      customPeptideType: '',
      fiveMod: '',
      fiveModCategory: '',
      flag: 0,
      format: 'DRY',
      fullSOligoBackbone: false,
      gcContent: '',
      id: (state.oligoCount + 1).toString(),
      internalModCategory: '',
      isLabelledAminoAcid: true,
      isoCode: false,
      isOverridden: false,
      itemId: '',
      listError: [
        {
          key: '',
          value: '',
        },
      ],
      material: '',
      meltingTemparature: '',
      minimumYield: '',
      molecularWeight: '',
      name: '',
      nterminalMod: '',
      oligoId: state.oligoCount + 1,
      orderItemId: '',
      otherValue: '',
      packageType: '',
      plateType: '',
      price: '',
      primerDimer: '',
      productType: productType,
      purification: '',
      purityLevel: '',
      quantitation: '',
      scale: '',
      secondaryStructure: '',
      sequence: '',
      sequenceLocation: '',
      threeMod: '',
      threeModCategory: '',
      tubes: '1',
    }
  }

  const addOligo = () => {
    if (
      sessionData.length <
      (productType === TubeProduct.iscaledna
        ? TubeProperties.MaximumOligosAllowedIscaledna
        : TubeProperties.MaximumOligosAllowed)
    ) {
      dispatch({ type: 'CALL_OVERRIDE_VALIDATION', data: false })
      dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
      dispatch({ type: 'CALL_TOTAL_VALIDATION', data: true })
      dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })
      dispatch({
        type: 'IS_VIEW_ALL_CLICK',
        data: false,
      })
      dispatch({
        type: 'IS_ADD_OLIGO',
        data: true,
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems }),
      })
      window.scrollTo(0, 0)
    }
  }

  // call when i am deleting any tube products
  const performTubeDelete = (item, type) => {
    let deleteAll = false

    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (OligoIndex !== 0) {
        const newIndex = OligoIndex - 1

        const array = [...state.sessionData]
        const index = array.indexOf(item)
        let deletedIndex = index
        if (index !== -1) {
          sessionData.splice(index, 1)
        }

        if (index > sessionData.length || index === sessionData.length) {
          deletedIndex = newIndex
        }

        dispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: newIndex,
        })
        dispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: deletedIndex,
        })
        dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: true })
        dispatch({
          type: 'CALL_RULE_VALIDATION',
          data: true,
        })
        dispatch({
          type: 'CALL_SESSION_API',
          data: true,
        })
        dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        deleteAll = false
      } else {
        deleteAll = true
      }
    } else if (type === 'All') {
      deleteAll = true
    }

    if (deleteAll) {
      dispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      dispatch({
        type: 'IS_COMING_FROM_REVIEW_PAGE',
        data: false,
      })
      dispatch({
        type: 'IS_CONCENTRATION_ENABLE',
        data: false,
      })
      dispatch({
        type: 'IS_LABEL_AMINO_ACID_ERROR',
        data: false,
      })
      dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })
      dispatch({
        type: 'IS_VIEW_ALL_CLICK',
        data: false,
      })
      sessionData.splice(0, sessionData.length)
      state.sessionData.push(setInitialState())
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({
        type: 'CALL_SESSION_API',
        data: true,
      })
      dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: false })
      dispatch({ type: 'UPDATE_OPTIONAL_BASES', data: '' })
      dispatch({ type: 'UPDATE_AQUA_INTERNAL_MOD', data: '' })
      dispatch({ type: 'IS_DELETE_ALL', data: true })
    }

    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    dispatch({
      type: 'IS_DELETE_PERFORM',
      data: true,
    })
    dispatch({
      type: 'IS_RESET_ERROR',
      data: true,
    })
    dispatch({
      type: 'SPECIFICATION_TOTAL_VALIDATION',
      data: false,
    })
    dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
    if (deleteAll) {
      setDialogOpen(false)
      dispatch({
        type: 'IS_VIEW_ALL_CLICK',
        data: false,
      })

      dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
      dispatch({
        type: 'IS_LABEL_AMINO_ACID_ERROR',
        data: false,
      })
    }

    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
  }

  // This method is use to perform delete and delete all operations
  const deleteOligoItem = (item, type) => {
    dispatch({ type: 'IS_TUBE_ITEM_DELETE', data: true })
    performTubeDelete(item, type)
  }

  React.useEffect(() => {
    if (isValidTotalValidation) {
      const newIndex = sessionData.length
      dispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: newIndex,
      })
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: newIndex,
      })

      const emptyStateObj = Object.assign({}, setInitialState())
      state.sessionData.push(emptyStateObj)
      dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })

      setTimeout(() => {
        if (!(sessionData.length !== 0 && sessionData[0].applyToAll)) {
          state.sessionData[newIndex].purification = ''
        }
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
      }, 10)
      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
      window.scrollTo(0, 0)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.oligoCount])

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelItem(item)
  }

  const displaySessionData = (e, data, index) => {
    e.preventDefault()
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: index,
    })

    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    dispatch({
      type: 'CALL_OVERRIDE_VALIDATION',
      data: true,
    })
    dispatch({
      type: 'CALL_TOTAL_VALIDATION',
      data: true,
    })
  }

  const displayIcon = (index) => {
    if (currentOligoIndex === index && isRequiredFieldError) {
      return true
    }
    //STRAT-16465 changes
    const priorityErr = sessionData[index].listError?.some(
      (obj) => obj.key === ConfiguratorValues.SequencePriority
    ) //STRAT-16465 changes

    const nameError = sessionData[index].listError?.some(
      (obj) => obj.key === messages.CONF_OLIGO_NAME_KEY.defaultMessage
    )
    if (
      sessionData[index].isOverridden &&
      !errorIcon &&
      !priorityErr &&
      !nameError
    ) {
      return false
    }

    if (sessionData[index]) {
      if (errorIcon) {
        if (totalValidationJSON && totalValidationJSON[index]) {
          const { listErrors } = totalValidationJSON[index]
          if (listErrors && listErrors.length !== 0) {
            return listErrors[0].key === ''
          } else {
            return false
          }
        }
        return false
      } else {
        const { listError } = sessionData[index]
        if (isTubePageLoad) {
          if (listError && listError.length !== 0) {
            let iserrorDisplay = false
            if (currentOligoIndex === index) {
              if (errorResponseJson) {
                if (
                  state.isSequenceValid &&
                  state.errorResponseJson.listFiveMod?.length === 1
                ) {
                  if (listError.length === 1 || listError.length === 2) {
                    listError.forEach((error) => {
                      if (error.key === Modification.ModFive) {
                        iserrorDisplay = false
                      }
                    })
                    return iserrorDisplay
                  }
                } else if (
                  state.isAmountChanged &&
                  state.errorResponseJson.listPurification &&
                  state.errorResponseJson.listPurification.length === 1 &&
                  (listError.length === 1 || listError.length === 2)
                ) {
                  return listError[0].key === TubeProperties.Purification
                }
              }
            } else if (listError[0].key === '') {
              return false
            }
            return true
          } else {
            return false
          }
        } else {
          if (listError && listError.length !== 0) {
            let iserrorDisplay = false
            if (currentOligoIndex === index) {
              listError.forEach((error) => {
                if (
                  !(
                    error.value === TubeProperties.RequiredField ||
                    error.value === TubeProperties.SelectionRequired ||
                    error.value === TubeProperties.SelectionRequiredError ||
                    error.value === TubeProperties.RequiredFieldError ||
                    error.value === TubeProperties.LabeledAminoAcidRequired
                  ) &&
                  error.key !== TubeProperties.ReviewError &&
                  error.key !== ''
                ) {
                  iserrorDisplay = true
                }
              })

              if (errorResponseJson) {
                if (
                  state.isSequenceValid &&
                  state.errorResponseJson.listFiveMod?.length === 1
                ) {
                  if (listError.length === 1 || listError.length === 2) {
                    listError.forEach((error) => {
                      if (error.key === Modification.ModFive) {
                        iserrorDisplay = false
                      }
                    })
                    return iserrorDisplay
                  }
                } else if (
                  state.isAmountChanged &&
                  state.errorResponseJson.listPurification &&
                  state.errorResponseJson.listPurification.length === 1 &&
                  listError.length !== 0
                ) {
                  listError.forEach((error) => {
                    if (error.key === TubeProperties.Purification) {
                      iserrorDisplay = false
                    }
                    return iserrorDisplay
                  })
                  return iserrorDisplay
                }
              }
            } else {
              if (listError.length !== 0) {
                iserrorDisplay = true
              }
            }

            return iserrorDisplay
          } else {
            return false
          }
        }
      }
    }
    return false
  }

  const renderData = () => {
    const result: any[] = []
    sessionData.map((item, index) =>
      result.push(
        <Grid
          container
          alignItems="flex-end"
          className={classes.listContainer}
          key={index}
        >
          <Grid item sm={1} className={classes.listIcon}>
            <img alt="hexes" src="/static/hexes.png" />
          </Grid>
          <Grid
            item
            sm={10}
            className={clsx(
              index === state.currentOligoIndex && classes.active
            )}
          >
            <Link
              href="#"
              onClick={(e) => displaySessionData(e, item, index)}
              className={clsx(classes.labelRoot, classes.activeLabel)}
            >
              {productType === TubeProduct.Aqua ||
              productType === TubeProduct.Cpeptide
                ? item.name || (
                    <FormattedMessage {...messages.CONF_NEW_PEPTIDE} />
                  )
                : item.name || 'New Oligo'}
            </Link>
            {displayIcon(index) ? (
              <ErrorIcon className={classes.errorIcon} />
            ) : (
              ''
            )}
          </Grid>
          <Grid item sm={1}>
            <IconButton
              aria-label="delete"
              className={classes.delete}
              onClick={() => {
                handleDelete(item)
              }}
              id="product-summary-item-delete"
              data-testid="product-summary-item-delete"
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </Grid>
        </Grid>
      )
    )

    return result
  }

  React.useEffect(() => {
    if (state.sessionData.length > 5) {
      setScrollBar(true)
    } else {
      setScrollBar(false)
    }
  }, [sessionData[state.currentOligoIndex], state.sessionData.length])

  return (
    <>
      <Box
        mt={50}
        id="product-summary-container"
        data-testid="product-summary-container"
      >
        <Grid
          container
          alignItems="flex-end"
          className={classes.header}
          justify="center"
        >
          <Grid item xs={12} sm={6}>
            <h3 className={classes.heading}>{header()}</h3>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.view}>
            <Button
              onClick={() => setDialogOpen(true)}
              className={clsx(
                classes.viewAll,
                isIE
                  ? scrollBar
                    ? classes.viewAllScrollIE
                    : classes.buttonTextIe
                  : scrollBar
                    ? classes.viewAllScroll
                    : ''
              )}
              id="view-all-link"
              data-testid="view-all-link"
            >
              <FormattedMessage {...messages.CONF_VIEW_ALL_SIDE_BAR} />
            </Button>
          </Grid>
        </Grid>

        <TableContainer className={scrollBar ? classes.tableContainer : ''}>
          {renderData()}
        </TableContainer>

        <Divider variant="middle" className={classes.divider} />
        <Grid container spacing={1} alignItems="flex-end">
          <Grid item>
            <Button
              size="medium"
              className={classes.button}
              startIcon={<AddIcon />}
              onClick={addOligo}
              id="add-oligo-sidebar-link"
              data-testid="add-oligo-sidebar-link"
            >
              <FormattedMessage
                {...messages[`CONF_ADD_OLIGO_SIDE_BAR_${productType}`]}
              />
            </Button>
          </Grid>
        </Grid>
      </Box>
      <DeleteDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        onDelete={deleteOligoItem}
        type={delType}
      />
      <ViewAllDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        viewAllItems={sessionData}
        setActive={setActive}
        onDelete={deleteOligoItem}
        productName={productType}
      />
    </>
  )
}

export default ProductsSummary
